import React, { useEffect, useState } from 'react';
import { Activity, Bot, FileText, Mail, Route, ShieldCheck } from 'lucide-react';
import LaborOperationsLayout from '../../../components/labor/LaborOperationsLayout';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';
import { legalOperationsService } from '../../../services/legalOperationsService';

const sections = [
  { title: 'إدارة الأدوار والصلاحيات', description: 'الأدوار النظامية ونطاقات الوصول للملفات.', icon: ShieldCheck },
  { title: 'إعدادات مسار القضايا', description: 'مراحل الانتقال والاعتماد والإسناد.', icon: Route },
  { title: 'إعدادات الذكاء الصناعي', description: 'مسار التحليل الداخلي والمراجعة البشرية.', icon: Bot },
  { title: 'قوالب طلب النواقص', description: 'رسائل طلب الهوية والعقد والمستندات.', icon: FileText },
  { title: 'قوالب الرسائل', description: 'التواصل مع العميل وإشعارات الحالة.', icon: Mail },
];

const LegalOperationsSettingsPage = () => {
  const { token } = useAdminAuth();
  const [events, setEvents] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    legalOperationsService.getActivity(token).then((data) => setEvents(data.events || [])).catch((requestError) => setError(requestError.message));
  }, [token]);

  return (
    <LaborOperationsLayout>
      <main className="mx-auto max-w-[1500px] px-6 pb-14 pt-10 sm:px-12" dir="rtl">
        <header className="lo-hero px-1 pb-9 pt-2">
          <p className="lo-kicker font-bold">PLATFORM CONFIGURATION</p>
          <h1 className="lo-heading legal-title mt-4 font-bold">إعدادات التشغيل</h1>
          <p className="lo-lead mt-3">ضبط سير العمل والقوالب والتحليل وسجل التغييرات الداخلي.</p>
        </header>
        <section className="lo-surface grid overflow-hidden rounded-[18px] md:grid-cols-2 xl:grid-cols-3">
          {sections.map(({ title, description, icon: Icon }) => (
            <article key={title} className="border-b border-[#e7e2d9] p-7 md:border-l">
              <Icon className="h-5 w-5 text-[#948066]" />
              <h2 className="legal-title mt-5 text-[18px] font-bold text-[#293a50]">{title}</h2>
              <p className="mt-2 text-[14px] leading-8 text-[#697483]">{description}</p>
              <button type="button" className="mt-5 text-[14px] font-bold text-[#806f58]">إدارة الإعدادات</button>
            </article>
          ))}
        </section>
        <section className="lo-surface mt-10 rounded-[18px] p-7">
          <div className="flex items-center gap-3"><Activity className="h-5 w-5 text-[#948066]" /><h2 className="legal-title text-[21px] font-bold text-[#293a50]">سجل النشاط</h2></div>
          {error && <p className="mt-4 text-sm text-[#99623b]">{error}</p>}
          <div className="mt-5 divide-y divide-[#f0e8dc]">
            {events.map((event) => (
              <div key={event.id} className="flex flex-wrap justify-between gap-3 py-5">
                <div><p className="text-[16px] font-bold text-[#293a50]">{event.title}</p><p className="mt-1 text-[14px] text-[#697483]">{event.description || event.type}</p></div>
                <p className="text-[14px] text-[#697483]">{event.actor_name}</p>
              </div>
            ))}
            {!events.length && !error && <p className="py-10 text-center text-sm text-[#8b94a0]">لا توجد أحداث تشغيلية مسجلة حتى الآن.</p>}
          </div>
        </section>
      </main>
    </LaborOperationsLayout>
  );
};

export default LegalOperationsSettingsPage;
